import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Router, browserHistory } from 'react-router';
import { syncHistoryWithStore, push } from 'react-router-redux';
import { custom } from 'utils/Api';
import { useSSO } from 'config';
import { notAuthenticated, authenticated, sso } from './actions/account/login';
import { setLanguage } from './actions/language';
import Account from './containers/Account';
import App from './containers/App';
import SSOApp from './containers/SSOApp';
import CourseEvaluation from './containers/CourseEvaluation';
import PageNotFound from './components/PageNotFound';
import Profile from './containers/Profile';
import Holiday from './containers/EmployeeHoliday';
import Payslip from './containers/Payslip';
import Courses from './containers/Courses';
import Benefits from './containers/Benefits';
import EmployeeSearch from './containers/EmployeeSearch';
import Agreements from './containers/Agreements';
import Appraisals from './containers/Appraisals';
import Appraisal from './containers/Appraisal';
import PMAppraisals from './containers/pmappraisals/PMAppraisals';
import PMAppraisal from './containers/pmappraisals/PMAppraisal';
import Settings from './containers/Settings';
import Dashboard from './containers/Dashboard';
import Files from './containers/Files';
import EmployeeOrgChart from './containers/EmployeeOrgChart';
import Time from './sites/time';
import Teria from './sites/teria/Teria';
import ResetPassword from './components/account/ResetPassword';

// New way of doing things

import TG from './sites/transportationGrants';
import Grants from './sites/grants';
import InOut from './sites/inOut/InOut';
import VacationApprovals from './sites/vacationApprovals/VacationApprovals';
import Paytickets from './sites/payTickets/Paytickets';
import ApprovalRequests from './sites/approvalRequests/ApprovalRequests';
import Pay from './sites/pay/Pay';

let authInterval = null;

class Routes extends Component {

  constructor(props) {
    super(props);
    this.routes = {
      path: '/',
      component: useSSO ? SSOApp : App,
      onEnter: this.checkLanguage,
      // indexRoute: { component: Profile, name: 'Mínar Upplýsingar', onEnter: this.authenticate },
      indexRoute: { component: Dashboard, name: 'Heim', onEnter: this.authenticate },
      childRoutes: [
        {
          path: 'me', component: Profile, name: 'Mínar Upplýsingar', onEnter: this.authenticate,
        },
        {
          path: 'account', component: Account, name: 'Innskráning',
        },
        {
          path: 'search', ID: 'Search', component: EmployeeSearch, name: 'Leit', onEnter: this.authenticate,
        },
        {
          path: 'evaluation/:CourseAttendeeID', ID: 'Learning', component: CourseEvaluation, name: 'Námskeiðsmat', onEnter: this.authenticate,
        },
        {
          path: 'pay', ID: 'Payroll', component: Pay, name: 'Launaupplýsingar', onEnter: this.authenticate,
        },
        {
          path: 'holiday', ID: 'Holiday', component: Holiday, name: 'Orlof', onEnter: this.authenticate,
        },
        {
          path: 'payslip', ID: 'PaySlip', component: Payslip, name: 'Launaseðlar', onEnter: this.authenticate,
        },
        {
          path: 'paytickets', ID: 'PayTicket', component: Paytickets, name: 'Launaseðlar', onEnter: this.authenticate, autoHide: true,
        },
        {
          path: 'courses', ID: 'Learning', component: Courses, name: 'Námskeið', onEnter: this.authenticate,
        },
        {
          path: 'courses/:courseId', ID: 'Learning', component: Courses, name: 'Námskeið', onEnter: this.authenticate,
        },
        {
          path: 'benefits', ID: 'Benefits', component: Benefits, name: 'Benefits', onEnter: this.authenticate,
        },
        {
          path: 'grants', ID: 'Grants', component: Benefits, name: 'Grants', onEnter: this.authenticate,
        },
        {
          path: 'grants/fitness', ID: 'FitnessGrants', component: Grants.Fitness, name: 'Grants', onEnter: this.authenticate,
        },
        {
          path: 'events', ID: 'Learning', component: Courses, name: 'Events', onEnter: this.authenticate,
        },
        {
          path: 'events/:courseId', ID: 'Learning', component: Courses, name: 'Events', onEnter: this.authenticate,
        },
        {
          path: 'agreements', ID: 'Agreements', component: Agreements, name: 'Agreements', onEnter: this.authenticate,
        },
        {
          path: 'appraisals', ID: 'PM', component: Appraisals, name: 'Frammistöðumat', onEnter: this.authenticate,
        },
        {
          path: 'appraisals/:appraisalId', ID: 'PM', component: Appraisal, name: 'Frammistöðumat', onEnter: this.authenticate,
        },
        {
          path: 'pmappraisals', ID: 'PM', component: PMAppraisals, name: 'Frammistöðumat', onEnter: this.authenticate,
        },
        {
          path: 'pmappraisals/:appraisalId', ID: 'PM', component: PMAppraisal, name: 'Frammistöðumat', onEnter: this.authenticate,
        },
        {
          path: 'files', ID: 'Repository', component: Files, name: 'Rafræn skjöl', onEnter: this.authenticate,
        },
        {
          path: 'transportation', ID: 'TransportationGrants', component: TG.TransportationGrants, name: 'Samgöngustyrkir', onEnter: this.authenticate,
        },
        {
          path: 'teria', ID: 'Teria', component: Teria, name: 'Mötuneyti og verslanir', onEnter: this.authenticate, autoHide: true,
        },
        {
          path: 'time', ID: 'Time', component: Time.TimeOverview, name: 'Viðvera', onEnter: this.authenticate, autoHide: true,
        },
        {
          path: 'inOut', ID: 'InOut', component: InOut, name: 'Inni/úti', onEnter: this.authenticate, autoHide: true,
        },
        {
          path: 'vacations', ID: 'VacationApprovals', component: VacationApprovals, name: 'Orlofsbeiðnayfirlit', onEnter: this.authenticate, autoHide: true,
        },
        {
          path: 'approvals', ID: 'ApprovalRequests', component: ApprovalRequests, name: 'Beiðnir', onEnter: this.authenticate, autoHide: true,
        },
        {
          path: 'settings', component: Settings, name: 'Stillingar', onEnter: this.authenticate,
        },
        { path: 'resetPassword/:code', component: ResetPassword, name: 'ResetPassword' },
        { path: '404', component: PageNotFound, name: '404' },
        {
          path: 'orgchart', ID: 'OrgChart', component: EmployeeOrgChart, name: 'Skipurit', onEnter: this.authenticate,
        },
        { path: '*', component: PageNotFound, name: '404' },
      ],
    };
    this.history = syncHistoryWithStore(browserHistory, this.props.store);
  }

  checkLanguage = () => {
    const { dispatch } = this.props.store;
    if (localStorage.language && (localStorage.language === 'is' || localStorage.language === 'en')) {
      dispatch(setLanguage(localStorage.language));
    } else {
      dispatch(setLanguage('is'));
    }
  }

  checkSSO = () => {
    const { dispatch, getState } = this.props.store;
    const { user } = getState().loginReducer;
    const { locationBeforeTransitions } = getState().routing;
    if (user.sso || (locationBeforeTransitions.query && locationBeforeTransitions.query.logout === 'true')) { return; }
    dispatch(sso());
  }

  authenticate = (nextState, replace) => {
    if (useSSO) {
      return;
    }
    const { dispatch, getState } = this.props.store;
    const { user } = getState().loginReducer;
    if (!(localStorage.EmployeeMasterID && localStorage.token) && !user.sso) {
      dispatch(notAuthenticated());
      let nextPathname = `${nextState.location.pathname}${nextState.location.search}`;
      if (localStorage.nextPath && localStorage.nextPath !== '') {
        nextPathname = localStorage.nextPath;
        localStorage.nextPath = '';
      }
      replace({ pathname: '/account', state: { nextPathname } });
      localStorage.nextPath = `${nextState.location.pathname}${nextState.location.search}`;
    } else {
      localStorage.nextPath = '';
      if (!authInterval) {
        authInterval = setInterval(() => {
          const cfg = {
            headers: {},
            url: '/api/qdata/version',
          };
          if (!user.sso) {
            cfg.headers.Authorization = `Bearer ${localStorage.token}`;
          }
          custom(cfg).catch(() => {
            clearInterval(authInterval);
            authInterval = null;
            dispatch(push('/account?logout=true'));
          });
          // s    ms
        }, 60 * 1000);
      }
      dispatch(authenticated({
        ...user,
        userName: localStorage.userName,
        token: !user.sso && localStorage.token,
        EmployeeMasterID: Number(localStorage.EmployeeMasterID),
        Gender: localStorage.Gender,
        DefaultEmployeeDetailID: Number(localStorage.DefaultEmployeeDetailID),
      }));
    }
  }

  render() {
    return (
      <Router history={this.history} routes={this.routes} />
    );
  }
}

Routes.propTypes = {
  store: PropTypes.object.isRequired,
};

export default connect(({ WebValuesReducer }) => ({ ...WebValuesReducer }))(Routes);



// WEBPACK FOOTER //
// ./src/routes.js